import api from './api'

export const moduleService = {
  // Get all modules
  getAll: async () => {
    const response = await api.get('/modules')
    return response.data.modules || []
  },

  // Get single module
  getById: async (id) => {
    const response = await api.get(`/modules/${id}`)
    return response.data.module
  },

  // Update module progress
  updateProgress: async (id, progressData) => {
    const response = await api.post(`/modules/${id}/progress`, progressData)
    return response.data
  },

  // Get draft submission for exercises
  getDraftSubmission: async (id) => {
    const response = await api.get(`/modules/${id}/exercise/draft`)
    return response.data
  },

  // Get exercise submission
  getExerciseSubmission: async (id) => {
    const response = await api.get(`/modules/${id}/exercise/submission`)
    return response.data
  },

  // Submit exercise/homework
  submitExercise: async (id, submissionData) => {
    const response = await api.post(`/modules/${id}/exercise/submit`, submissionData)
    return response.data
  },
}
